import { Outlet } from "react-router-dom";
import SidebarMenu from "../admin_pages/sidebarmenu/SidebarMenu";
import { useState, useEffect } from "react";

const AdminLayout = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      {/* Wrapper for SidebarMenu */}
      <div
        style={{
          maxWidth: "1280px",
          margin: "0 auto",
        }}
      >
        <SidebarMenu isOpen={isOpen} setIsOpen={setIsOpen} />
      </div>

      {/* Wrapper for Admin Content */}
      <div
        style={{
          maxWidth: "1280px",
          margin: "0 auto",
        }}
      >
        <div
          className="admin-content"
          style={{
            marginLeft: isOpen ? "19%" : "0",
            width: isOpen ? "81%" : "100%",
            transition: "margin-left 0.3s ease, width 0.3s ease",
            paddingLeft: isOpen ? (isMobile ? "8px" : "2rem") : isMobile ? "8px" : "20px",
            paddingRight: isMobile ? "8px" : "20px",
            marginBottom: "30px",
          }}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
